import { ShieldAlert } from 'lucide-react';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface MedicalRecordsValidationDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MedicalRecordsValidationDialog = ({
  isOpen,
  onClose,
}: MedicalRecordsValidationDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent className="z-[60] max-w-md" overlayClassName="z-[60]">
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <ShieldAlert className="h-5 w-5 text-red-600" />
            <AlertDialogTitle>
              Medical Records Task Requires a Treatment Record Request
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-gray-600 dark:text-zinc-400">
            Medical Records tasks cannot be created manually. To create
            this task, please go to the{' '}
            <span className="font-medium text-gray-900 dark:text-white">
              Treatment
            </span>{' '}
            tab and create a{' '}
            <span className="font-medium text-gray-900 dark:text-white">
              Record Request
            </span>{' '}
            for a specific provider instead. The associated Medical
            Records task will be generated automatically.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="outline" onClick={onClose}>
              Got It
            </Button>
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
